export default __webpack_public_path__ + "static/media/file17.ed5c11b5.jpg";